import { render, staticRenderFns } from "./new_report_whole.vue?vue&type=template&id=bae6f6d8&scoped=true&"
import script from "./new_report_whole.vue?vue&type=script&lang=js&"
export * from "./new_report_whole.vue?vue&type=script&lang=js&"
import style1 from "./new_report_whole.vue?vue&type=style&index=1&id=bae6f6d8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bae6f6d8",
  null
  
)

export default component.exports